import React from "react";
import { Dropdown } from "react-bootstrap";
import { FiCheck, FiMonitor, FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "./ThemeProvider";

const modes = [
  { value: "light", label: "Light", Icon: FiSun },
  { value: "dark", label: "Dark", Icon: FiMoon },
  { value: "auto", label: "Auto", Icon: FiMonitor },
];

export default function ThemeControl({ placement = "floating" }) {
  const { mode, resolvedTheme, setMode } = useTheme();
  const { Icon, label } = modes.find((item) => item.value === mode);
  return (
    <div className={`theme-control theme-control--${placement}`}>
      <Dropdown align="end" drop={placement === "sidebar" ? "up" : "down"} autoClose>
        <Dropdown.Toggle className="theme-toggle" variant="link" id={`theme-menu-${placement}`} aria-label={`Appearance: ${label}${mode === "auto" ? ` (${resolvedTheme})` : ""}`} title="Appearance">
          <Icon aria-hidden="true" />
        </Dropdown.Toggle>
        <Dropdown.Menu role="menu" aria-label="Appearance">
          {modes.map(({ value, label: optionLabel, Icon: OptionIcon }) => (
            <Dropdown.Item key={value} as="button" type="button" role="menuitemradio" aria-checked={mode === value} active={mode === value} onClick={() => setMode(value)}>
              <OptionIcon aria-hidden="true" /><span>{optionLabel}</span>{mode === value && <FiCheck aria-hidden="true" />}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}